module.exports = __webpack_public_path__ + "img/air_burgundy.45db6205.svg";